<ion-content>
  <div class="checkmark-design">
    <ion-icon name="checkmark"></ion-icon>
  </div>
  <h1 class="title-text">
    {{ "voucher-redeem.redeemed" | translate }} <br />
    {{ "voucher-redeem.voucher" | translate }}
  </h1>
  <p>{{ "voucher-redeem.Another" | translate }}</p>
  <ion-button size="small" expand="block" (click)="openCompleteProfilePage()" class="action-btn-large" type="submit">
    {{
      voucherSuccessResponse?.paid_button_label
        ? (voucherSuccessResponse?.paid_button_label | uppercase)
        : (voucherSuccessResponse?.button_label | uppercase)
        || ("voucher-dialog.button_label" | translate)
    }}</ion-button
  >
</ion-content>
